import { u as h, g as f, a as g, b as _, _ as b } from "./ds-atom-stars-CkXbhJOm.js";
import { c as $, v as z } from "./ds-atom-stars-CkXbhJOm.js";
import { storeToRefs as v } from "pinia";
import { useCssVars as w, useSlots as y, ref as k, createElementBlock as i, openBlock as c, createElementVNode as d, normalizeClass as M, createCommentVNode as l, withModifiers as S, renderSlot as m, unref as u } from "vue";
/* empty css              */
const A = async (e, s = "en") => {
  const a = h(), { countryCode: t, countryMaskFile: o, countryValidatorFile: r, language: n } = v(a);
  t.value = e, o.value = new (await f(e))(), r.value = new (await g(e))(), n.value = s;
}, V = () => {
  const e = _(), { setDevice: s } = e, a = window.matchMedia("(max-width: 767px)"), t = window.matchMedia("(min-width: 768px) and (max-width: 1024px)"), o = window.matchMedia("(min-width: 1024px)"), r = a.matches ? "mobile" : t.matches ? "tablet" : o.matches ? "desktop" : "";
  s(r), [a, t, o].forEach((n) => {
    n.addEventListener("change", () => {
      const p = a.matches ? "mobile" : t.matches ? "tablet" : o.matches ? "desktop" : "";
      s(p);
    });
  });
}, x = { class: "accordion-item-container" }, H = ["innerHTML"], C = {
  key: 0,
  class: "accordion-item__answer"
}, T = ["innerHTML"], D = {
  __name: "ds-molecule-accordion-item",
  props: {
    background: {
      type: String,
      required: !1,
      default: ""
    },
    iconExpand: {
      type: String,
      required: !1,
      default: ""
    },
    iconCollapse: {
      type: String,
      required: !1,
      default: ""
    },
    subHeader: {
      type: String,
      required: !1,
      default: null
    },
    paragraph: {
      type: String,
      required: !1,
      default: null
    }
  },
  setup(e) {
    w((r) => ({
      abb8a772: s.background,
      "778140e8": s.iconExpand,
      "00659fc2": s.iconCollapse
    }));
    const s = e, a = y(), t = k(!1), o = () => {
      t.value = !t.value;
    };
    return (r, n) => (c(), i("div", x, [
      d("article", {
        class: M([
          "accordion-item",
          {
            "accordion-item--open": t.value
          }
        ])
      }, [
        d("div", {
          class: "accordion-item__header",
          onClick: S(o, ["prevent"])
        }, [
          u(a).subHeader ? m(r.$slots, "subHeader", {
            key: 0,
            classes: ["steps__sub-header"]
          }, void 0, !0) : e.subHeader ? (c(), i("div", {
            key: 1,
            class: "steps__sub-header",
            innerHTML: e.subHeader
          }, null, 8, H)) : l("", !0),
          n[0] || (n[0] = d("button", { class: "accordion-item__button" }, [
            d("span", { class: "accordion-item__icon" })
          ], -1))
        ]),
        u(a).paragraph || e.paragraph ? (c(), i("div", C, [
          u(a).paragraph ? m(r.$slots, "paragraph", {
            key: 0,
            classes: ["accordion-item__paragraph"]
          }, void 0, !0) : e.paragraph ? (c(), i("div", {
            key: 1,
            class: "accordion-item__paragraph",
            innerHTML: e.paragraph
          }, null, 8, T)) : l("", !0)
        ])) : l("", !0)
      ], 2)
    ]));
  }
}, I = /* @__PURE__ */ b(D, [["__scopeId", "data-v-08821ef5"]]);
export {
  $ as DsAtomStars,
  I as DsMoleculeAccordionItem,
  A as setupDesignSystemComponentLibrary,
  _ as useUserStore,
  z as validateValue,
  V as watchDeviceType
};
//# sourceMappingURL=main.es.js.map
